export const indianStates = [
  { label: "Andhra Pradesh", value: "Andhra Pradesh", code: "AP" },
  { label: "Arunachal Pradesh", value: "Arunachal Pradesh", code: "AR" },
  { label: "Assam", value: "Assam", code: "AS" },
  { label: "Bihar", value: "Bihar", code: "BR" },
  { label: "Chhattisgarh", value: "Chhattisgarh", code: "CG" },
  { label: "Goa", value: "Goa", code: "GA" },
  { label: "Gujarat", value: "Gujarat", code: "GJ" },
  { label: "Haryana", value: "Haryana", code: "HR" },
  { label: "Himachal Pradesh", value: "Himachal Pradesh", code: "HP" },
  { label: "Jharkhand", value: "Jharkhand", code: "JH" },
  { label: "Karnataka", value: "Karnataka", code: "KA" },
  { label: "Kerala", value: "Kerala", code: "KL" },
  { label: "Madhya Pradesh", value: "Madhya Pradesh", code: "MP" },
  { label: "Maharashtra", value: "Maharashtra", code: "MH" },
  { label: "Manipur", value: "Manipur", code: "MN" },
  { label: "Meghalaya", value: "Meghalaya", code: "ML" },
  { label: "Mizoram", value: "Mizoram", code: "MZ" },
  { label: "Nagaland", value: "Nagaland", code: "NL" },
  { label: "Odisha", value: "Odisha", code: "OD" },
  { label: "Punjab", value: "Punjab", code: "PB" },
  { label: "Rajasthan", value: "Rajasthan", code: "RJ" },
  { label: "Sikkim", value: "Sikkim", code: "SK" },
  { label: "Tamil Nadu", value: "Tamil Nadu", code: "TN" },
  { label: "Telangana", value: "Telangana", code: "TG" },
  { label: "Tripura", value: "Tripura", code: "TR" },
  { label: "Uttar Pradesh", value: "Uttar Pradesh", code: "UP" },
  { label: "Uttarakhand", value: "Uttarakhand", code: "UK" },
  { label: "West Bengal", value: "West Bengal", code: "WB" },
  { label: "Andaman & Nicobar", value: "Andaman & Nicobar", code: "AN" },
  { label: "Chandigarh", value: "Chandigarh", code: "CH" },
  { label: "Dadra & Nagar Haveli", value: "Dadra & Nagar Haveli", code: "DN" },
  { label: "Daman & Diu", value: "Daman & Diu", code: "DD" },
  { label: "Delhi", value: "Delhi", code: "DL" },
  { label: "Jammu & Kashmir", value: "Jammu & Kashmir", code: "JK" },
  { label: "Ladakh", value: "Ladakh", code: "LA" },
  { label: "Lakshadweep", value: "Lakshadweep", code: "LD" },
  { label: "Puducherry", value: "Puducherry", code: "PY" },
];


export const getStateCode = (stateName) => {
  if (!stateName) return "";
  const found = indianStates.find(
    (s) => s.value.toLowerCase() === stateName.toLowerCase()
  );
  return found ? found.code : stateName;
};